import AOS from "aos";

export const setupAOS = () => {
    AOS.init({
        easing: "ease-in-out",
        once: true,
        duration: 1000,
    });
};

export const setupIframes = () => {
    const iframes = document.querySelectorAll("iframe");
    iframes.forEach((iframe) => {
        iframe.classList.add("-detected");
        iframe.removeEventListener("load", onIframeLoad);
        iframe.addEventListener("load", onIframeLoad);
    });

    function onIframeLoad(e) {
        e.target.classList.add("-loaded");
    }
};
